import { getPostHogClient } from "./posthog";

// Central custom-event seam. Event names use human-readable Title Case and
// property names use snake_case, matching the existing product events.
export function trackEvent(
  name: string,
  properties?: Record<string, unknown>,
): void {
  getPostHogClient()?.capture(name, properties ?? {});
  if (typeof import.meta !== "undefined" && (import.meta as any).env?.DEV) {
    // eslint-disable-next-line no-console
    console.debug("[track]", name, properties ?? {});
  }
}
